import { formatDistanceDisplay } from '../../../helpers/data-helpers';
import { isTimestampNow } from './relative-time';

interface Sortable {
  timestamp?: string;
  distance_from_member?: number;
}

/**
 * Sort signals/members by "on the water" status first, then by distance.
 * - On the water (now): sorted by most recent timestamp
 * - Not on the water: sorted by distance (closest first)
 */
export const sortByOnWaterThenDistance = <T extends Sortable>(
  items: T[],
): T[] =>
  [...items].sort((a, b) => {
    const aIsOnWater = isTimestampNow(a.timestamp);
    const bIsOnWater = isTimestampNow(b.timestamp);

    // Prioritise members currently on the water
    if (aIsOnWater && !bIsOnWater) return -1;
    if (!aIsOnWater && bIsOnWater) return 1;

    // Sort by distance (closest first)
    return (
      (a.distance_from_member || Infinity) -
      (b.distance_from_member || Infinity)
    );
  });

/**
 * Format a distance value to a display string in nautical miles.
 */
export const formatDistanceFromMember = (
  distanceFromMember?: number,
): string => {
  if (!distanceFromMember) return '';

  const distanceInNm = (
    formatDistanceDisplay(distanceFromMember, {
      distance: 'nm',
    }) as { value: number }
  )?.value;

  return `${distanceInNm.toFixed(0)}nm`;
};
